module.exports = __webpack_public_path__ + "img/footer.9e876e61.jpg";